
import Vue from 'vue'

import {
  VIcon,
  VListItem,
  VListItemGroup,
  VListItemIcon,
  VListItemTitle,
} from 'vuetify/lib'
import { filteredMenu, userInfo, utilityItem } from '@/util/navUtilities'

export default Vue.extend({
  name: 'JcdcUtilityMenuLinks',
  components: {
    VIcon,
    VListItem,
    VListItemGroup,
    VListItemIcon,
    VListItemTitle,
  },
  props: {
    userInfo: { type: Object as () => userInfo, required: true },
    utilityList: { type: Array as () => utilityItem[], default: (): [] => [] },
  },
  methods: {
    filteredMenu,
  },
})
